import React from 'react';
import PropTypes from 'prop-types';
import Select from '../Select';
import {
  ALL_ROLES,
  COMPANY_ROLES,
  ADMINS as ADMIN_ROLES,
  COMPANY_ADMINS as COMPANY_ADMIN_ROLES,
} from '../../../constants/userRoles';


const UserRoleDropdown = ({ value, onChange, onlyCompany, hasActiveCompanyAdmin }) => {
  const companyRoles = hasActiveCompanyAdmin ? COMPANY_ROLES : COMPANY_ADMIN_ROLES;
  const allRoles = hasActiveCompanyAdmin ? ALL_ROLES : ADMIN_ROLES;
  const options = onlyCompany ? companyRoles : allRoles;
  return (
    <Select
      value={value}
      onChange={onChange}
      options={options}
    />
  );
};

UserRoleDropdown.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
  onlyCompany: PropTypes.bool,
  hasActiveCompanyAdmin: PropTypes.bool,
};

export default UserRoleDropdown;



// WEBPACK FOOTER //
// src/components/shared/UserRoleDropdown/index.jsx